// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ty-0";